<div class="filter-row">
  <div *ngFor="let t of types" [ngClass]="t.active ? t.label == currentSelected ? 'filter-item selected' : 'filter-item not-selected' : 'filter-item not-active'" (click)="select(t)">
    <img [src]="t.active ? t.label == currentSelected ? './assets/ui/svg/white/' + t.label + '-icon.svg' : './assets/ui/svg/grey/' + t.label + '-icon.svg' : './assets/ui/svg/white/' + t.label + '-icon.svg'">
    <span>{{t.label}}</span>
  </div>
</div>
